import $ from "jquery";
import _ from "underscore";
import Ajax from "shared/ajax";

export function errorFromResponse({ errors = {} }) {
  console.log(errors);
  const apiError = new Error();
  apiError.original = errors;
  apiError.apiError = true;
  apiError.errors = Object.entries(errors).reduce(
    (obj, [error, values]) => {
      if (values) {
        obj[error] = _.flatten([values]).join(',');
      }
      return obj;
    },
    {}
  );
  apiError.baseErrors = Object.entries(errors).map(
    ([error, value]) => `${error}: ${value}`
  );

  return apiError;
}

export default class RESTClient {
  constructor(apiBase, { singular = false } = {}) {
    this.apiBase = apiBase;
    this.isSingularResource = singular;
  }

  get = (id = "") =>
    this.fetch(`${this.apiBase}/${this.isSingularResource ? "" : id}`);

  list = async(queryParams = {}) =>
    this.isSingularResource
      ? [await this.get()]
      : this.fetch(this.apiBase, { body: queryParams });

  create = data =>
    this.fetch(this.apiBase, { method: "POST", body: JSON.stringify(data) });

  update = ({ id, ...data }) =>
    this.fetch(`${this.apiBase}/${this.isSingularResource ? "" : id}`, {
      method: "PUT",
      body: JSON.stringify(data)
    });

  delete = id =>
    this.fetch(`${this.apiBase}/${this.isSingularResource ? "" : id}`, {
      method: "DELETE"
    });

  fetch(url, { body, ...options } = {}) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url,
        success: resolve,
        error: ({ responseJSON = {} }) =>
          reject(errorFromResponse(responseJSON)),
        data: body,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": Ajax.getCsrfToken()
        },
        credentials: "include",
        ...options
      });
    });
  }
}
